var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBluetooth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bluetooth") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.933 1.781c0-1.529 1.74-2.321 2.843-1.366l0.116 0.109 6.933 7.11c0.635 0.651 0.674 1.68 0.119 2.379l-0.119 0.135-5.708 5.853 5.708 5.853c0.635 0.651 0.674 1.68 0.119 2.379l-0.119 0.135-6.933 7.11c-1.054 1.081-2.831 0.379-2.952-1.096l-0.007-0.161v-9.93l-3.974 4.077c-0.635 0.651-1.639 0.691-2.32 0.122l-0.132-0.122c-0.635-0.651-0.674-1.68-0.119-2.379l0.119-0.135 5.708-5.853-5.708-5.853c-0.635-0.651-0.674-1.681-0.119-2.379l0.119-0.135c0.635-0.651 1.639-0.691 2.32-0.122l0.132 0.122 3.974 4.076v-9.928zM18.4 20.291v5.637l2.749-2.818-2.749-2.819zM18.4 6.072v5.637l2.749-2.818-2.749-2.819z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluetooth);
export default __webpack_public_path__ + "static/media/bluetooth.4cc8a78222131c26fe410a6bcad54785.svg";
export { ForwardRef as ReactComponent };